exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user_title {\n  color: #4EBD74; }\n\n.page_title {\n  color: #E749D7; }\n\n.group_title {\n  color: #0073FA; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard7/dashboard7.component.scss
// module id = ../../../../../src/app/views/dashboards/dashboard7/dashboard7.component.scss
// module chunks = main